import {UserScheduleList} from "../components/schedule-list";
import {SchedulesHeader} from "../components/schedules-header";
import {UserScheduleProvider} from "../context/user-schedule";

export function GetUserSchedulesPage() {
  return (
    <div>
      <UserScheduleProvider>
        <SchedulesHeader />
        <UserScheduleList />
      </UserScheduleProvider>
    </div>
  );
}
